const METRIC = 'JS_LOGGER_FRONTEND_ERROR';
const getServiceUrl = () => `${Odigeo.Settings.property('appContext')}/service/jslogger/log`;
const TAG_EXTERNAL_SCRIPT = 'external-script-injection';
const STACK_JOIN_LABEL = '... ';
const CLIENT_INFO = _.values(_.pick(window.bowser, ['osname', 'osversion', 'name', 'version'])).join(':');
const LOG_LEVEL_ERROR = 'ERROR';
const LOG_LEVEL_INFO = 'INFO';
const LOG_LEVEL_WARN = 'WARN';
const logLevel = {
    level: LOG_LEVEL_ERROR,
    setLevel: (level) => logLevel.level = level,
    getLevel: () => logLevel.level,
};
const requestHeaders = (requestParams = {}) => ({
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    credentials: 'same-origin',
    method: 'PUT',
    body: JSON.stringify(requestParams),
});

const serviceJsLogger = function(message, fileName, lineNumber, column, errorStackStringify) {
    // eslint-disable-next-line no-restricted-properties
    return window.fetch(getServiceUrl(), requestHeaders({
        message,
        fileName,
        lineNumber,
        logLevel: logLevel.getLevel(),
        column: column || 0,
        hash: window.location.hash,
        stack: errorStackStringify,
        queryString: window.location.search.substr(1),
        client: CLIENT_INFO,
        page: Odigeo.History.getPageNameFromFragment(),
    }))
        .then((response) => response.ok ? trackMetric() : disableLoggers())
        .catch(() => disableLoggers());
};

const disableLoggers = () => {
    Logger.message = () => {
    };
    Logger.error = () => {
    };
};

const trackMetric = () => {
    const trackingUtils = require('../utils/tracking.utils');

    trackingUtils.counterMetric(METRIC, {
        FUNNEL: Odigeo.Utils.getFunnelInGlobalScope(),
        PAGE: Odigeo.History.getPageNameFromFragment(),
    });
};

const getSourceName = (fileName) => {
    let sourceName = TAG_EXTERNAL_SCRIPT;

    if (!_.isEmpty(fileName)) {
        sourceName = fileName.split('/');
        sourceName = sourceName[sourceName.length - 1];
    }
    return sourceName;
};

const parseStackTrace = (message = '', stackFrames) => {
    const {fileName, lineNumber, columnNumber} = stackFrames[0];
    const errorStackStringify = stackFrames.map((sf) => sf.toString()).join(`\n\t${STACK_JOIN_LABEL}`);

    return serviceJsLogger(message, getSourceName(fileName.trim()), lineNumber, columnNumber, STACK_JOIN_LABEL + errorStackStringify);
};

const Logger = {
    info: (msg) => !Odigeo.Utils.isHomePage() && window.StackTrace.get().then((stackFrames) => {
        logLevel.setLevel(LOG_LEVEL_INFO);
        return parseStackTrace(msg, stackFrames);
    }),
    message: (msg) => !Odigeo.Utils.isHomePage() && window.StackTrace.get().then((stackFrames) => {
        logLevel.setLevel(LOG_LEVEL_ERROR);
        return parseStackTrace(msg, stackFrames);
    }),
    error: (error, msg) => {
        if (!Odigeo.Utils.isHomePage()) {
            const errorInstance = error instanceof Error ? error : new Error(JSON.stringify(error));
            if (window && window.StackTrace) {
                return window.StackTrace.fromError(errorInstance).then((stackFrames) => {
                    logLevel.setLevel(LOG_LEVEL_ERROR);
                    return parseStackTrace(msg, stackFrames);
                });
            }
        }
    },
    warn: (msg) => !Odigeo.Utils.isHomePage() && window.StackTrace.get().then((stackFrames) => {
        logLevel.setLevel(LOG_LEVEL_WARN);
        return parseStackTrace(msg, stackFrames);
    }),
    disableLoggers,
};

module.exports = Logger;
